export const apiVersionPrefix: string = "/api/v2";

export const packagesApiPrefix: string = `${apiVersionPrefix}/packages`;
export const getPackageApiPath: string = `${packagesApiPrefix}/getPackage`;
export const finalizePackageApiPath: string = `${packagesApiPrefix}/finalize`;
export const flightTripDetailsApiPath: string = `${packagesApiPrefix}/flightTripDetails`;
